import styled from "styled-components";
import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {grayColors} from "../../../../../../themes/architecture/gray-colors";
import {hexToRgba} from "../../../../../../themes/hex-to-rgba";

export const GenericSideMenuItemDefaultBox = styled.div<{active?: boolean}>`
    display: flex;
    align-items: center;
    padding: 0.8rem 0;
    font-size: 1.4rem;
    line-height: 1;
    color: ${({theme, active}) => active ? theme.colors.textActive : theme.colors.text};
    transition: color 0.2s ease;
    @media ${({theme}) => theme.mediaQuery.lowHeight}, ${({theme}) => theme.mediaQuery.xlAndBelow} {
        padding: 0.6rem 0;
    }
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        ${({theme}) => theme.font.presets.regular};
        padding: 1rem 0;
        color: ${({theme, active}) => active ? theme.colors.textActive : theme.colors.textLight};
        font-weight: 300;
    }
    &:hover {
        color: ${({theme}) => theme.colors.textHover};
    }
`;

const GenericSideMenuItemCasino888Box = styled(GenericSideMenuItemDefaultBox)`
    display: flex;
    align-items: center;

    border: 1px solid;
    border-color: ${({theme, active}) => active ? theme.colors.brandPrimary : 'transparent'};
    border-radius: 100px;
    background-color: ${({theme, active}) => active ? hexToRgba(theme.colors.logoBackground, 0.2) : 'transparent'};
    color: ${({theme, active}) => active ? theme.colors.textActive : theme.colors.textLight};
    font-size: 14px;
    ${({theme}) => theme.font.presets.medium};
    padding-block: 1rem;
    padding-inline: ${({active}) => active ? '4.5rem' : '1.5rem'};
    margin: ${({active}) => active && '0 0 0 -3rem'};

    transition: color 0.2s ease, background-color 0.2s ease;
    
    @media ${({theme}) => theme.mediaQuery.lAndAbove} {
        color: ${({theme, active}) => active ? theme.colors.textActive : grayColors.gray203};
        font-size: 12px;
        font-weight: unset;
        padding: 1rem;
        margin: 0 1rem;
    }
    
    &:hover {
        color: ${({theme, active}) => active ? theme.colors.textActive : theme.colors.textHover};
    }
`;

const GenericSideMenuItemCasino777Box = styled(GenericSideMenuItemDefaultBox)`
    color: ${({theme, active}) => active ? theme.colors.backgroundActive : theme.colors.text};
`;

const GenericSideMenuItemWsopBox = styled(GenericSideMenuItemDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-weight: ${({theme, active}) => active ? 600 : 300};
    }
`;

export const GenericSideMenuItemBox = styledByTheme(GenericSideMenuItemDefaultBox)
    .forCasino888(GenericSideMenuItemCasino888Box)
    .forCasino777(GenericSideMenuItemCasino777Box)
    .forWsop(GenericSideMenuItemWsopBox)
    .apply();
